export const SCROLL_TIMEOUT = 500;
export const VISIBLE_PADDING = 300;
export const DEFAULT_CONTAINER_WIDTH = 1024;
export const DEFAULT_SPACING = 16;
// See https://zpl.io/VKPoDRR
export const DEFAULT_BREAKPOINTS = [
    {
        maxWidth: 480,
        elementWidth: 343,
        elementHeight: 239
    },
    {
        maxWidth: 1024,
        elementWidth: 304,
        elementHeight: 261
    },
    {
        maxWidth: 1280,
        elementWidth: 288,
        elementHeight: 247
    },
    {
        maxWidth: 1366,
        elementWidth: 299.5,
        elementHeight: 257
    },
    {
        maxWidth: 1920,
        elementWidth: 347.2,
        elementHeight: 300
    }
];
export const pageMarginByScreenWidth = {
    480: 68.5,
    1024: 40,
    1280: 40,
    1366: 60,
    1920: 60
};
